import * as TypeActions from './actionsTypes';

export const loadMapaCompleto = (filter) => ({
  type: TypeActions.NSIR_MAPA_LOAD_COMPLETO,
  filter,
});

export const cleanMapaCompleto = () => ({
  type: TypeActions.NSIR_MAPA_CLEAN_ALL,
});
